import { createStore } from 'satcheljs';
export default createStore('senderImageOption', {
    showSenderImageInListView: null,
})();
//# sourceMappingURL=store.js.map